import React, { useState, useEffect } from "react";
import TablePagination from "../CommonComponents/NewPagination/NewPagination";
import { Card, Col } from "react-bootstrap";
import Table from "../../sharedPages/CommonComponents/Table";
import SearchBar from "../CommonComponents/SearchBar/SearchBar";
import dropdownAngle from "../../../assets/images/dropdownAngle.svg";
import { Link } from "react-router-dom";

const columns = [
  { key: "groupName", label: "Group name" },
  { key: "price", label: "Price" },
  { key: "month", label: "Month" },
  { key: "status", label: "Status" },
  { key: "renews", label: "Renews" },
  { key: "invoice", label: "Invoice" },
];

const positions = [
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "Short",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "Long",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "Short",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "Long",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "Short",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
  {
    asset: "100X_Bonkie1000/USDT",
    trade: "long",
    opened: "28.10.2024",
    pnlPercent: "112%",
    pnlDollar: "$1293",
  },
];

const SubscriptionHistory = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div className="d-flex justify-content-end">
        <Link to="#" className="changeCreditCardCta">Change your credit card {">"}</Link>
      </div>
      <div className="tableWrapper">
        <div className="tableCaptionWrap row align-items-center flex-md-row flex-column-reverse">
          <Col md="3" sm="12">
            <div className="memberFilteDropdown">
              <div className="dropdown">
                <button
                  className="dropdown-btn"
                  // ref={filterButtonRef}
                  // disabled={hasExistingOrder}
                  style={{
                    backgroundColor: "",
                    borderColor: "",
                    //   color: isOpen ? "#000000" : "#9a9b9b",
                  }}
                >
                  Select Year
                  <img
                    alt=""
                    className={`arrow ${isOpen && "rotate"}`}
                    src={dropdownAngle}
                  />
                </button>
                {isOpen && (
                  <>
                    <ul className="dropdown-menu">
                      <div className="switchSide p-0 justify-content-sm-end justify-content-center">
                        <div className="switchBase">
                          <button>Monthly</button>
                          <button>Yearly</button>
                        </div>
                      </div>
                    </ul>
                  </>
                )}
              </div>
            </div>
          </Col>
          <Col md="9" sm="12" className="text-end position-relative">
            <SearchBar
              mainDivStyle={{
                justifyContent: "end",
              }}
              svgStyle={{
                marginLeft: "0px",
                marginRight: "20px",
              }}
            />
          </Col>
        </div>
        <div className="d-md-block d-none">
          <Table
            columns={columns}
            //   data={currentTableData}
            //   currentPage={currentPage}
            //   onPageChange={setCurrentPage}
            stylingComp={{ marginTop: "0px" }}
            // showCheckbox={true}
            // selectedRows={selectedRows}
            // onRowSelect={handleRowSelect}
          />
        </div>
        <div className="tableMobView d-md-none d-block">
          {positions.map((pos, index) => (
            <Card key={index} className="border-0 border-bottom tableCard">
              <Card.Body className="px-0">
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center assetColumn">
                    <h6>Asset</h6>
                    <p>{pos.asset}</p>
                  </div>
                  <p style={{ flexBasis: "40px" }}>{pos.trade}</p>
                </div>
                <div className="d-flex justify-content-between">
                  <div>
                    <h6>Opened</h6>
                    <p>{pos.opened}</p>
                  </div>
                  <div>
                    <h6>PNL (%)</h6>
                    <p>{pos.pnlPercent}</p>
                  </div>
                  <div>
                    <h6>PNL ($)</h6>
                    <p>{pos.pnlDollar}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
          <div className="mt-3 pt-2">
            <TablePagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionHistory;
